// extracted by css-extract-rspack-plugin
export default {"content":"CxKQ6","image":"jNeK7","label_container":"Opmi_","labelContainer":"Opmi_","title":"LvKeL","description":"I5oUW"};